import { useEffect } from 'react'
import HitComponent from './HitComponent'
import NoResults from './NoResults'
import SearchEasterEgg from '../../../../assets/frontend/js/easterEggs/SearchEasterEgg'
import { scrollIntoView } from '../../../../assets/frontend/js/utils/dom'
import { t } from '../../../../assets/utils/algolia/algoliaLocalization'
import type { BaseHit, Hit } from 'instantsearch.js'

type HitListProps = {
  layout: 'card' | 'list'
  items: Hit<BaseHit>[]
}

// TODO: check if scrollIntoView is working here

function HitList({ layout, items }: HitListProps) {
  const visibleItems = items.filter(
    (item) => !!item.isDenominationGlobal || !!item.isRegionGlobal || !!t(item.title, { fallback: 'lang' })
  )

  // biome-ignore lint/correctness/useExhaustiveDependencies: Only way
  useEffect(() => {
    const widget = document.querySelector('.events-list')
    const filterPanel = widget?.querySelector('.filter-panel')
    const isStickyFilter = filterPanel?.classList.contains('is-sticky')
    if (!widget || !isStickyFilter) return
    scrollIntoView(widget as HTMLElement, { offset: 10 })
  }, [items])

  if (visibleItems.length === 0) {
    return (
      <>
        <SearchEasterEgg source="events-list" noResults />
        <NoResults />
      </>
    )
  }

  return (
    <>
      <SearchEasterEgg source="events-list" noResults={false} />
      {layout === 'card' ? (
        <div className="grid events-list-hits z-0">
          {visibleItems.map((item) => (
            <div
              key={item.objectID}
              className="g-col g-col-12 g-col-md-6 g-col-lg-4"
            >
              <HitComponent hit={item} variant="card" />
            </div>
          ))}
        </div>
      ) : layout === 'list' ? (
        <div className="events-list-hits space-y-2">
          {visibleItems.map((item) => (
            <div key={item.objectID}>
              <HitComponent hit={item} variant="list" />
            </div>
          ))}
        </div>
      ) : null}
    </>
  )
}

export default HitList
